<mat-toolbar class="filter-panel" *ngIf="isFiltereable">
    <app-hierarchy-filter [gadget]="gadget" (selectionChanged)="filterSelectionChanged()"></app-hierarchy-filter>

</mat-toolbar>

<mat-toolbar>
    <button mat-button color="primary" [disabled]="!this.gadget.year || !this.gadget.companyId"
            (click)="export()">{{ 'downloadExcelFile' | translate }}</button>
</mat-toolbar>